/*
 * @description: 内容管理配置文件
 * @author: Jsj
 * @Compile：2021-01-27 13：00
 * @update: Jsj(2021-01-27 13：00)
 */
export default [
  {
    path: '/material',
    component: resolve =>
      require(['../pages/content/material/material.vue'], resolve),
    name: 'material',
    title: '素材管理',
    meta: {
      title: '素材管理'
    }
  }
]
